import { render, staticRenderFns } from "./chooseBusinessPrice.vue?vue&type=template&id=4bc4eae0&scoped=true"
import script from "./chooseBusinessPrice.vue?vue&type=script&lang=js"
export * from "./chooseBusinessPrice.vue?vue&type=script&lang=js"
import style0 from "./chooseBusinessPrice.vue?vue&type=style&index=0&id=4bc4eae0&prod&lang=scss"
import style1 from "./chooseBusinessPrice.vue?vue&type=style&index=1&id=4bc4eae0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bc4eae0",
  null
  
)

export default component.exports